import React, { useEffect, useRef, useMemo } from 'react';
import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { BoardColumn } from './Column';
import { AddNewStage } from './Stage';
import { useBoardData } from '../../context/BoardContext';
import { useFilters } from '../../context/FilterContext';
import { useBoardSection } from 'modules/TasksV2/context';

const KanbanBoard = () => {
  const boardScrollRef = useRef(null);
  const { taskStages } = useBoardData();
  const filters = useFilters();
  const { caseDetails } = useBoardSection();

  // Build filter object for columns - memoized to prevent breaking child memoization
  const filterParams = useMemo(
    () => ({
      searchKeyword: filters.searchKeyword,
      practiceArea: filters.practiceArea,
      assignedTo: filters.assignedTo,
      sortType: filters.sortType,
      dateFilter: filters.dateFilter,
      priority: filters.priority,
      case_id: caseDetails?.case_id || undefined,
    }),
    [
      filters.searchKeyword,
      filters.practiceArea,
      filters.assignedTo,
      filters.sortType,
      filters.dateFilter,
      filters.priority,
      caseDetails?.case_id,
    ]
  );

  useEffect(() => {
    const cleanups = [];

    if (boardScrollRef.current) {
      cleanups.push(
        autoScrollForElements({
          element: boardScrollRef.current,
          canScroll: ({ source }) => source.data.type === 'card' || source.data.type === 'column',
        })
      );
    }

    cleanups.push(
      autoScrollForElements({
        element: document.documentElement,
      })
    );

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, []);

  return (
    <div className="d-flex">
      <div className="kanban-board thin-scrollbar" ref={boardScrollRef}>
        <div className="board-scroll-container">
          {taskStages?.map((column, index) => (
            <BoardColumn key={column.task_stage_id} column={column} index={index} filters={filterParams} />
          ))}
          <AddNewStage />
        </div>
      </div>
    </div>
  );
};

// Memoize to prevent unnecessary rerenders
export default React.memo(KanbanBoard);
